(function () {
    'use strict';

    /**
     * @ngdoc object
     *
     *
     * @description
     *
     */
    angular
        .module('missingSignIn')
        .controller('SignInCtrl', SignInCtrl);

    function SignInCtrl($uibModalInstance, modalParams, MissingSignInService, MessageService,EventManagerService) {
        var vm = this;
        vm.ctrlName = 'SignInCtrl';

        vm.model = {
            signInData: {
            	crewScheduleBlockId : modalParams.crewScheduleBlockId,
            	signInDate : modalParams.checkInDate,
            	signInTime : modalParams.checkInTime,
            	isLegal : modalParams.isLegal,
            	comment : null
            }
        };

        vm.doSignIn = function () {
        	MissingSignInService.doSignIn(vm.model.signInData,
                  function (response) {
                     if (response.success) {
                    	$uibModalInstance.close();
                        MessageService.success(MessageService.MESSAGES.CREWING.SUCCESS_SAVE_MESSAGE);
                		EventManagerService.notifyEventListeners(EventManagerService.EVENT.MISSIN_SIGN_IN.RELOAD_SIGN_IN_DATA);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
         };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());
